import { For, Show, createResource } from "solid-js";
import { MonsterArtwork } from "~/features/students/MonsterArtwork";
import { studentMoodEmoji } from "./studentFormatting";
import type { StudentMyClassModule } from "./studentMyClass";
import type { StudentClass } from "./student";

export function StudentMyClassPage(props: {
  value: StudentClass | undefined;
  module: StudentMyClassModule;
}) {
  const [data, { refetch }] = createResource(
    () => props.value?.id,
    (classId) => props.module.load(classId)
  );

  return (
    <div>
      <div class="card-header" style={{ "margin-bottom": "20px" }}>
        <h1>Meine Klasse</h1>
        <button class="btn btn-secondary btn-sm" type="button" onClick={() => void refetch()}>
          ↻ Aktualisieren
        </button>
      </div>

      <Show when={data.loading}>
        <div style={{ display: "flex", "justify-content": "center", padding: "60px" }}>
          <div class="loading-spinner" />
        </div>
      </Show>

      <Show when={data.error}>
        <div class="card">
          <p style={{ color: "var(--error)" }}>Klasse konnte nicht geladen werden.</p>
        </div>
      </Show>

      <Show when={data()}>
        {(snapshot) => (
          <div class="grid-3">
            <For each={snapshot().classmates}>
              {(mate) => {
                const isSelf = () => mate.student_id === snapshot().selfId;
                return (
                  <div
                    class="card"
                    style={{
                      "text-align": "center",
                      position: "relative",
                      border: isSelf() ? "2.5px solid var(--primary)" : undefined,
                    }}
                  >
                    <Show when={isSelf()}>
                      <span
                        style={{
                          position: "absolute",
                          top: "8px",
                          right: "10px",
                          "font-size": "0.7rem",
                          "font-weight": 700,
                          color: "var(--primary)",
                          background: "var(--surface-alt, #f0f4ff)",
                          padding: "2px 8px",
                          "border-radius": "20px",
                        }}
                      >
                        Du
                      </span>
                    </Show>

                    <div class="monster-container" style={{ "margin-bottom": "8px" }}>
                      <div class="monster-stage" style={{ transform: "scale(0.75)", "transform-origin": "center top", height: "100px" }}>
                        <MonsterArtwork level={mate.level} alt={mate.monster_name ?? "Monster"} layered />
                      </div>
                    </div>

                    <div style={{ "font-weight": 700, "font-size": "0.95rem", "margin-bottom": "6px" }}>
                      {mate.monster_name ?? "?"}
                    </div>

                    <div style={{ "font-size": "1.4rem" }}>
                      <Show
                        when={mate.morning_mood != null}
                        fallback={
                          <span title="Noch nicht eingecheckt" style={{ opacity: 0.35, "font-size": "1rem" }}>
                            —
                          </span>
                        }
                      >
                        <span title={`Stimmung: ${mate.morning_mood}`}>
                          {studentMoodEmoji(mate.morning_mood)}
                        </span>
                      </Show>
                    </div>
                  </div>
                );
              }}
            </For>
          </div>
        )}
      </Show>

      <Show when={data() && data()!.classmates.length === 0}>
        <div class="card" style={{ "text-align": "center", padding: "40px" }}>
          <p style={{ color: "var(--text-muted)" }}>Noch niemand in dieser Klasse.</p>
        </div>
      </Show>
    </div>
  );
}
